import { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { INTERACTION_ORIGIN } from '@constants/tracking';
import CarouselV2 from '@common/Carousel/containers/CarouselV2';
import { useTranslation } from '@common/Hooks/useTranslation';
import { Product } from '@common/Listing/types';
import { RECENTS_ITEMS_PARAMETERS as itemsParameters } from '@common/MyLists/constants';
import { openRecents } from '@common/MyLists/store/actions/MyListsActions';
import ProductCardRedesign from '@common/ProductCard/containers/ProductCardRedesign';

interface RecentProductsCarouselProps {
    imageDimension: string;
}

export function RecentProductsCarousel({ imageDimension }: RecentProductsCarouselProps) {
    const productsContainerRef = useRef<HTMLDivElement | null>(null);

    const dispatch = useDispatch();

    const translate = useTranslation();

    const recents = useSelector((state: any) => state.recents);

    const products: Product[] = recents?.products;
    const productsCount = products.length;
    const limit = 10;

    if (!productsCount) {
        return null;
    }

    const headlineAction = {
        label: `${translate('View.all.translation.key')} (${productsCount})`,
        callback: () => {
            dispatch(openRecents());
        },
    };

    const cardStrings = {
        soldOutLabel: translate('product_history.sold_out.label'),
        quantity: translate('shopcart.quantity.label'),
        comingSoon: translate('brandaz.coming-soon.label'),
    };

    return (
        /* @ts-ignore */
        <CarouselV2
            ref={productsContainerRef}
            className=""
            group=""
            headlineAction={headlineAction}
            title={translate('product.details.recently_viewed.label')}
        >
            {products.slice(0, limit).map((product, index) => {
                const bmpTrackingData = {
                    totalProducts: products.length,
                    productsPerPage: limit,
                    itemIndex: index,
                    group: itemsParameters.item_list_name,
                    containerOffsetWidth: productsContainerRef.current?.offsetWidth,
                };

                return (
                    /* @ts-ignore */
                    <ProductCardRedesign
                        key={product.variants[0].id}
                        cardStrings={cardStrings}
                        customDescriptionComponent={null}
                        imageSizes={{ dimension: imageDimension }}
                        product={product}
                        topHeaderComponent={null}
                        trackingValues={{
                            bmp: bmpTrackingData,
                            list: itemsParameters.item_list_name,
                            itemsParameters,
                            interactionOrigin: INTERACTION_ORIGIN.recent,
                        }}
                        type="RFListingLeftSticky"
                    />
                );
            })}
        </CarouselV2>
    );
}
